import { render } from "./SchedaVisualizzazioneContenuto.vue?vue&type=template&id=0c628536"
import script from "./SchedaVisualizzazioneContenuto.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneContenuto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__